import React from 'react'
import { useDispatch } from 'react-redux'
import t from '../../i18n/translations/translations'
import './PrecioCambiado.css'
import Cross from '../../assets/svg/Cross'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { MI_PAGO_HARTU_FUNCIONALITY } from '../../constants/hartu'
import { tributariaPayNow, tributariaPayLater } from '../../store/actions'
import InfoPay from '../../assets/svg/hartu/InfoPay'
import { useNavigate } from 'react-router-dom'

function PrecioCambiado({
    isOpened,
    handleClose,
    total_price,
    tributaria_price,
    lang,
    bookingDate,
    startBookingHour,
    facilityName,
    handleYesButton
}) {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    return (
        <Dialog
            id="dialog-content"
            open={isOpened}
            onClose={handleClose}
            className="dialogContainer"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Button onClick={handleClose} className="closeButton">
                <Cross width="20px" />
            </Button>
            <DialogTitle id="alert-dialog-title">
                <>
                    <div className="alert-dialog-title-message">{t.datos_reserva["eu"]}</div>
                    <div className="alert-dialog-title-message-subtitle">{t.datos_reserva["es"]}</div>
                </>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="hartuBookingform__confirmation">
                        <h3>{t.price_change[lang]}</h3>
                        <div className="hartuBookingform__confirmation_content_modal">
                            <div>
                                <i className="fa-solid fa-building fa-lg" />
                                <p>{facilityName}</p>
                            </div>
                            <div>
                                <i className="fa fa-calendar fa-lg" />
                                <div className='diplayBlock'>
                                    {bookingDate.map((date, index) => (
                                        <div key={index}>
                                            <p>{date}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <i className="fa fa-credit-card fa-lg" />
                                <p>{t.price_anterior[lang]}</p>
                                <p style={{ marginLeft: '8px' }}>{`${total_price} €`}</p>
                            </div>
                            <div>
                                <i className="fa fa-credit-card fa-lg" />
                                <p>{t.price_actualizado_tributaria[lang]}</p>
                                <p style={{ marginLeft: '8px' }}>{`${tributaria_price} €`}</p>
                            </div>
                            <div>
                                <p>{t.price_actualizado_tributaria_sms[lang]}</p>
                            </div>
                        </div>
                        <div></div>
                    </div>
                </DialogContentText>
                <div id="form-content" className="tributariaPayButtons">
                    <Button 
                        onClick={handleYesButton}
                        className="payBookingButton"
                    >
                        {t.yes[lang]}
                    </Button>
                    <Button
                        onClick={handleClose}
                        className="payBookingButton"
                    >
                        {t.no[lang]}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default PrecioCambiado
